import { render, staticRenderFns } from "./CustomizeMetalC.vue?vue&type=template&id=29a97d08&scoped=true"
import script from "./CustomizeMetalC.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalC.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalC.vue?vue&type=style&index=0&id=29a97d08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a97d08",
  null
  
)

export default component.exports